import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/demandRecord/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/demandRecord/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/demandRecord/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/demandRecord/updateById', data)
}
